import { Button, DateField, Descriptions, Divider, Icons, message, PageHeader, Space, Tag, Typography } from '@pankod/refine-antd'
import { IResourceComponentsProps, useShow } from '@pankod/refine-core'
import { IEvaluationRequests } from 'interfaces'
import { EvaluationList } from 'components/evaluations'
import { useEffect, useRef, useState } from 'react'
import { getMultipleUsers } from 'users'
import { getQuestionLookupIdsByUuids } from 'gql/query'
import { CSVLink } from 'react-csv'
import metaData from 'metadata/evaluationRequest'
import { evaluationUploadFormat } from 'helpers/import_template_format/importTemplate'
import {
  convertResponseReportToEvaluationCsv,
  downloadCsvFile,
} from 'helpers/evaluations/convertResponseReportFormat'
const { ExportOutlined, SwapOutlined } = Icons
export const ShowEvaluationRequest: React.FC<IResourceComponentsProps> = () => {
  const [evaluators, setEvaluators] = useState([] as any[])
  const [evaluatorsName, setEvaluatorsName] = useState('')
  const [converting, setConverting] = useState(false)
  const convertFileInputRef = useRef<HTMLInputElement>(null)
  const { queryResult } = useShow<IEvaluationRequests>({
    resource: 'evaluation_requests',
    metaData,
  })

  const { data, isLoading, refetch } = queryResult
  const record = data?.data
  useEffect(() => {
    const assignedEvaluatorsDuplicated = record?.evaluators?.map(evaluatorEvaluation => evaluatorEvaluation?.evaluator?.displayName)
    const assignedEvaluators = assignedEvaluatorsDuplicated?.filter((userName, idx) => assignedEvaluatorsDuplicated?.indexOf(userName) === idx)
    setEvaluators(assignedEvaluators ?? [])
    // getMultipleUsers(JSON.stringify(record?.evaluator_ids)).then((response: any) => {
    //   setEvaluators(response?.users)
    // })
  }, [record])

  // useEffect(() => {
  //   let arr: object[] = []
  //   let text: string = ''
  //   if (evaluators?.length > 0) {
  //     arr = evaluators.filter(
  //       (elem: any, index: any, self: any) =>
  //         self.findIndex((t: any) => {
  //           return t.id === elem.id
  //         }) === index
  //     )
  //   }

  //   arr.map((item: any, i: any) => {
  //     text = text.concat(item?.displayName)
  //     if (i < arr.length) text = text.concat(',')
  //   })
  //   setEvaluatorsName(text)
  // }, [evaluators])
  const csvData = [evaluationUploadFormat.map(item => item.toString())]

  const handleConvertFormatClick = () => {
    convertFileInputRef.current?.click()
  }

  const handleConvertFormatFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    setConverting(true)
    try {
      const fileBuffer = await file.arrayBuffer()
      const paperQuestionKeys = record?.paper?.questionAnswerKeys || []
      const questionUuids = Array.from(
        new Set(paperQuestionKeys.map((key: { id: string }) => key.id).filter((id: string) => Boolean(id)))
      ) as string[]
      const questionLookups = questionUuids.length > 0 ? await getQuestionLookupIdsByUuids(questionUuids) : []
      const { csv, rowCount, questionCount } = convertResponseReportToEvaluationCsv(
        fileBuffer,
        paperQuestionKeys,
        questionLookups
      )
      const baseName = file.name.replace(/\.(xlsx|xls|csv)$/i, '')
      downloadCsvFile(csv, `${baseName}_evaluation_format.csv`)
      message.success(`Converted ${rowCount} candidate(s) with ${questionCount} question column(s).`)
    } catch (error) {
      message.error(error instanceof Error ? error.message : 'Failed to convert the uploaded file.')
    } finally {
      setConverting(false)
      event.target.value = ''
    }
  }

  return (
    <>
      <PageHeader
        className={`site-page-header-responsive `}
        ghost={false}
        title={`#${record?.request_id}-${record?.name}`}
        extra={[
          <Space>
            <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
              Back
            </Button>
          </Space>,

          <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
            <CSVLink key="export" data={csvData} filename={`evaluation_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
              <ExportOutlined /> Download Import Format
            </CSVLink>
          </Button>,
          <Button key="convert format" type="default" style={{ marginLeft: '5px' }} loading={converting} onClick={handleConvertFormatClick}>
            <SwapOutlined /> Convert Format
          </Button>,
          <input
            ref={convertFileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            style={{ display: 'none' }}
            onChange={handleConvertFormatFile}
          />,
        ]}
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="">{<Tag color="blue">{record?.status}</Tag>}</Descriptions.Item>
        </Descriptions>
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Slot">{<DateField value={record?.slot_selected} format="LLL" />}</Descriptions.Item>

          <Descriptions.Item label="Test Event">{`${record?.test_events?.name}`}</Descriptions.Item>
          <Descriptions.Item label="Paper"> {`#${record?.paper?.paper_id}-${record?.paper?.paper_smart_id}`}</Descriptions.Item>
        </Descriptions>
        <Divider style={{ margin: ' 0', paddingBottom: 5 }} />
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="Evaluation In Charge">
            <Typography.Text keyboard>{record?.evaluationInCharge?.displayName}</Typography.Text>
          </Descriptions.Item>

          <Descriptions.Item label="Evaluators">
            {evaluators?.length > 0 && evaluators?.map((name: any) => <Typography.Text keyboard>{name}</Typography.Text>)}
          </Descriptions.Item>
        </Descriptions>
      </PageHeader>
      <EvaluationList record={record} />
    </>
  )
}
